/**
 * Role-aware landing route. Every role has a canonical home; sending a platform_admin to
 * /home (the student page) is wrong. This is used by Login, register wizards, and any
 * post-auth redirect. Keep this list in sync with router.tsx.
 */

export function landingFor(role: string | undefined | null): string {
  if (!role) return '/home';
  if (role === 'platform_admin' || role === 'platform_operator' || role === 'platform_viewer') return '/platform';
  if (role === 'group_admin' || role === 'group_manager' || role === 'group_accountant') return '/group/overview';
  if (role === 'principal' || role === 'vice_principal') return '/principal/overview';
  if (role === 'tpo' || role === 'assistant_tpo' || role === 'registrar' || role === 'accountant' || role === 'admissions_officer') return '/tpo/today';
  if (role === 'hod' || role === 'placement_coordinator') return '/hod/department';
  if (role === 'faculty' || role === 'mentor_faculty') return '/faculty/mentees';
  if (role === 'partner_admin' || role === 'recruiter' || role === 'hiring_manager' || role === 'partner_accountant' || role === 'technical_panel') return '/company/campus-hiring';
  if (role === 'university_admin' || role === 'university_registrar' || role === 'university_exam_controller') return '/group/overview';
  // Students (student, student_representative) + everything else
  return '/home';
}
